import { useMutation } from '@tanstack/react-query';
import { patchSuggestedArticle, SuggestionStatus } from 'app/services/suggestedArticle';

import useFetchHelpCenter from '../fetch/useFetchHelpCenter';

function useSetSuggestedArticleStatus(suggestionStatus: SuggestionStatus) {
  const { data: helpCenter } = useFetchHelpCenter();

  return useMutation({
    mutationFn: () =>
      patchSuggestedArticle({
        uuid: helpCenter?.uuid || '',
        suggestionStatus,
      }),
  });
}

export function useSetSuggestedArticleShown() {
  return useSetSuggestedArticleStatus(SuggestionStatus.SHOWN);
}

export function useSetSuggestedArticleVisited() {
  return useSetSuggestedArticleStatus(SuggestionStatus.VISITED);
}

export function useSetSuggestedArticleClosed() {
  return useSetSuggestedArticleStatus(SuggestionStatus.CLOSED);
}
